function showTimer()
{ 
    return;
    //deprecrated
    if (listArrays[allColumns.indexOf('timer')][trialRow]!="na")
    {
    // startTimer(listArrays[allColumns.indexOf('presTime')][trialRow]/1000);
    startTimer(listArrays[allColumns.indexOf('timer')][trialRow]/1000);
    show("timer");
    }
}

window.timers = {};
window.listTrialTimerLabels = [];
window.timerNoLabelCount = 0;
window.currentTimerLabel = '';

function precomputeTimerValue(trialRow) {
    const timerValue = columnForTrial('timer', trialRow);

    if (timerValue === "na") {

        if (columnForTrial('type', trialRow) === 'form') {
            const formStartPageTrialRow = findFormStartPageTrialRow(trialRow);
            const timerLabel = window.listTrialTimerLabels[formStartPageTrialRow];
            if (timerLabel) {
                window.listTrialTimerLabels[trialRow] = timerLabel;
                return;
            }
        }

        window.listTrialTimerLabels[trialRow] = '';
        return;
    }

    const timerOptions = parseTimerValue(timerValue);

    window.listTrialTimerLabels[trialRow] = timerOptions.label;
    if (!window.timers[timerOptions.label] && timerOptions.totalDuration) {
        window.timers[timerOptions.label] = timerOptions;
    }
}

function precomputeTimerSkips(trialOrder) {
    for (var trialIndex = 1; trialIndex < trialOrder.length; trialIndex++) {
        const currentLabel = window.listTrialTimerLabels[trialIndex];
        const prevLabel = window.listTrialTimerLabels[trialIndex - 1];
        if (prevLabel && currentLabel != prevLabel) {
            //We found the trial to which the previous timer skips
            window.timers[prevLabel].skipTo = trialIndex;

            if(currentLabel && trialIndex === trialOrder.length - 1) {
                window.timers[currentLabel].skipTo = trialIndex + 1;
            }
        }
    }
    const lastTrial = trialOrder.length - 1;
    const lastLabel = window.listTrialTimerLabels[lastTrial];
    if(lastLabel) {
        window.timers[lastLabel].skipTo = lastTrial + 1;
    }
    return;
}

function parseTimerValue(value) {
    const positions = {
      topleft: 'topLeft',
      bottomleft: 'bottomLeft',
      topright: 'topRight',
      bottomright: 'bottomRight',
      top: 'top',
      bottom: 'bottom',
      center: 'center',
    }
    const timerRegex = /^((\d+)([m|s])?(\d+s)?)|\d+$/gm;
    const skipRegex = /skip/gmi;
    const locationRegex = new RegExp('^(?:(' + Object.keys(positions).join(')|(') + '))$', 'gmi');
    const stopwatchRegex = /stopwatch/gmi;
    const colorRegex = /^(?<color>(#[a-fA-F0-6]{3,6})|(\w+))\s+last\s+(?<seconds>\d+)s/gmi;
    const labelRegex = /^[a-zA-Z]+/gm;
    const sizeRegex = /^(?<size>s|m|l|xl)$/gmi;
    const oldTimerRegex = /^\d+$/gmi;
    const hideRegex = /hide/gmi;

    const options = {
        totalDuration: 0,
        isStopWatch: false,
        dangerThreshold: 0,
        position: 'topRight',
        elapsed: 0,
        size: 's',
        isHidden: false,
    };
    
    const splitValue = value.split(':');
    var timerOptions, label, labelMatch;
    if (splitValue.length > 1) {
        timerOptions = splitValue[1];
        label = splitValue[0];
    } else if((labelMatch = labelRegex.exec(splitValue[0])) !== null){
        label = labelMatch[0];
        return {label: label};
    } else if(oldTimerRegex.test(splitValue[0])) {
        options.totalDuration = parseInt(splitValue[0], 10) / 1000;
        options.label = generateLabel();
        return options;
    } else {
        timerOptions = splitValue[0];
    }

    var colorMatches;
    var sizeMatches;

    const timerOptionsSplit = timerOptions.split(',');
    for(var optionIndex = 0; optionIndex < timerOptionsSplit.length; optionIndex++) {
        const currentOption = timerOptionsSplit[optionIndex].trim();
        if (timerRegex.test(currentOption)) {
            options.totalDuration = parseTime(currentOption);
        } else if (skipRegex.test(currentOption)) {
            options.skip = true;
        } else if (locationRegex.test(currentOption)) {
            options.position = positions[currentOption.toLowerCase()] || options.position;
        } else if (stopwatchRegex.test(currentOption)) {
            options.isStopWatch = true;
        } else if (hideRegex.test(currentOption)) {
            options.isHidden = true;
        } else if (colorMatches = colorRegex.exec(currentOption)) {
            options.dangerThreshold = parseInt(colorMatches.groups['seconds']);
            options.dangerColor = colorMatches.groups['color'];
        } else if (sizeMatches = sizeRegex.exec(currentOption)) {
            options.size = sizeMatches.groups['size'].toLowerCase();
        }
    }

    if (label) {
        options.label = label;
    } else {
        options.label = generateLabel();
    }

    return options;
}



function generateLabel() {
    const noLabelPrefix = 'nl';
    window.timerNoLabelCount++;
    return noLabelPrefix + window.timerNoLabelCount;
}

function showNewTimer(timerObject) {
    timerObject.elapsed = 0;
    timerObject.stopped = false;

    const displayTimer = createDisplayTimer(
        timerObject.totalDuration,
        new Date() - timerObject.elapsed * 1000,
        timerObject
    )

    timingTimer(displayTimer, timerObject)
}

function timingTimer(draw, timerObject) {
    var lastDrawTimestamp = 0;
    function timer(timestamp) {
        // don't redraw with every frame, but at about 0.5 seconds (0.5 instead of 1 just to be sure we don't miss a second)
        if (!lastDrawTimestamp || timestamp - lastDrawTimestamp >= 500) {
            lastDrawTimestamp = timestamp;
            draw();
        }
        if((timerObject.elapsed < timerObject.totalDuration || !timerObject.stopped) && window.currentTimerLabel === timerObject.label) {
            window.requestAnimationFrame(timer);
        }
    }
    window.requestAnimationFrame(timer);
}

function cleanTimers() {
    if (window.timers[window.currentTimerLabel]) {
        window.timers[window.currentTimerLabel].stopped = true;
    }
    document.querySelectorAll('.timer-container').forEach(function (el) { 
      el.textContent = '';
    })
}

function initTimers() {
  window.timers = [];
  window.timerNoLabelCount = 0;
  window.listTrialTimerLabels = [];
  window.currentTimerLabel = '';
}

function findFormStartPageTrialRow(trialRow) {
    if (trialRow < 1) {
        return trialRow;
    }
    
    const trialRowType = columnForTrial('type', trialRow);
    const isForm = function(type){ return type === 'form'};
    if (!isForm(trialRowType)) {
        return trialRow;
    }

    const previousTrialRowType = columnForTrial('type', trialRow - 1);
    // trialRow is the start of a form
    if (!isForm(previousTrialRowType)) {
        return trialRow;
    }
    
    const isPreviousTrialRowPageBreak = columnForTrial('pageBreak', trialRow - 1) == '1';
    // trialRow is the first on a new page
    if (isPreviousTrialRowPageBreak) {
        return trialRow
    }

    return findFormStartPageTrialRow(trialRow -1);
}